<script setup>
import { store } from '@/store/appStore.js'
const p = store.pharmacyV2.profile
</script>

<template>
  <div>
    <div class="card module-header">
      <h2>{{ p.pharmacyName }}</h2>
    </div>
    <div class="split-2col">
      <div class="card" style="padding:20px;">
        <div class="eyebrow" style="margin-bottom:14px;">Identity &amp; Licensing</div>
        <dl style="display:grid;grid-template-columns:auto 1fr;gap:8px 16px;margin:0;font-size:13px;">
          <dt class="cell-muted">Customer ID</dt><dd style="margin:0" class="cell-strong">{{ p.customerId }}</dd>
          <dt class="cell-muted">Owner</dt><dd style="margin:0">{{ p.ownerName }}</dd>
          <dt class="cell-muted">Drug License</dt><dd style="margin:0">{{ p.drugLicenseNo }}</dd>
        </dl>
      </div>
      <div class="card" style="padding:20px;">
        <div class="eyebrow" style="margin-bottom:14px;">Contact</div>
        <dl style="display:grid;grid-template-columns:auto 1fr;gap:8px 16px;margin:0;font-size:13px;">
          <dt class="cell-muted">Mobile 1</dt><dd style="margin:0">{{ p.mobile1 }}</dd>
          <dt class="cell-muted">Mobile 2</dt><dd style="margin:0">{{ p.mobile2 || '—' }}</dd>
          <dt class="cell-muted">Email 1</dt><dd style="margin:0;word-break:break-all;">{{ p.email1 }}</dd>
          <dt class="cell-muted">Email 2</dt><dd style="margin:0;word-break:break-all;">{{ p.email2 || '—' }}</dd>
        </dl>
      </div>
      <div class="card" style="padding:20px;">
        <div class="eyebrow" style="margin-bottom:14px;">Address</div>
        <dl style="display:grid;grid-template-columns:auto 1fr;gap:8px 16px;margin:0;font-size:13px;">
          <dt class="cell-muted">Address</dt><dd style="margin:0">{{ p.address }}</dd>
          <dt class="cell-muted">City</dt><dd style="margin:0">{{ p.city }}</dd>
          <dt class="cell-muted">State</dt><dd style="margin:0">{{ p.state }}</dd>
          <dt class="cell-muted">Pincode</dt><dd style="margin:0">{{ p.pincode }}</dd>
        </dl>
      </div>
      <div class="card" style="padding:20px;">
        <div class="eyebrow" style="margin-bottom:14px;">Sales Contact</div>
        <dl style="display:grid;grid-template-columns:auto 1fr;gap:8px 16px;margin:0;font-size:13px;">
          <dt class="cell-muted">Assigned Sales Executive</dt><dd style="margin:0">{{ p.assignedSalesExec }}</dd>
        </dl>
      </div>
    </div>
  </div>
</template>
